import { render, staticRenderFns } from "./TransporterContractDetails.vue?vue&type=template&id=e8714488"
import script from "./TransporterContractDetails.vue?vue&type=script&lang=js"
export * from "./TransporterContractDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports